import Model from '../common/model';

export default class ImageDetailsModel extends Model {
    data?: Array<IData>;
    business_id?: string;
    Business_name?: string;
    date_time?: string;
    farm_site_id?: string;
    location?: string;
    observation_id?: number;
    obs_type?: string;
    pond_culture_id?: string;
    pond_id?: string;
    pond_name?: string;
    section_id?: string;
    section_name?: string;
    updated_on?: string;
    total_images?: number;
    count?: number;
    description?: string;
    Download?: boolean;
    Farm_id?: string;
    function?: string;
    image?: string;
    observation_type?: string;
    Site_id?: string;
    status?: boolean;
    Updated_on?: string;
    image_type?: string;
    image_count?: number;
    image_url?: string | ArrayBuffer;
    date: string;
    farm_id?: string;
    site_id?: string;
    check_tray_id?: string;
    Section_id?: string;
    meal?: string;
    desc?: string;
    fileType?: string;
    image_path?: string;
    final_size?: string;

    constructor() {
        super();
        this.data = new Array();
    }
}

//////////////////////////////
//IData
//////////////////////////////
export class IData {
    Business_name: string;
    location: string;
    section_name: string;
    pond_name: string;
    business_id: string;
    farm_site_id: string;
    section_id: string;
    pond_id: string;
    pond_culture_id: string;
    updated_on: Date;
    date_time: Date;
    sampling_id: number;

    constructor() { }
}
